<template>
<div :class="sideMenu ? 'w-full' : 'w-full pb-32'">
  <div v-if="!sideMenu" class="hidden lg:block relative w-full">
    <div class="absolute left-0 top-0 bg-black bg-opacity-20 w-full h-full z-1"></div>
    <img :src="mainImageTop ? `/${mainImageTop} ` : '/mainImageTop.jpg'" alt="" class="w-full h-96 object-cover relative">
  </div>
  <div class="flex flex-col px-0 md:px-5 xl:px-32 prod-area" :class="sideMenu ? 'px-0 pt-28 md:pt-44 main-area ml-auto' : 'w-full lg:w-10/12 lg:min-w-7xl mx-auto'">
    <div class="pt-8">
      <mobile-categories></mobile-categories>
    </div>
    <div class="flex top-2-area w-full mx-auto aic jcb" :class="sideMenu ? 'px-5 md:px-12' : 'px-5'">
      <div class="flex w-full pb-5 lg:pt-0 border-b relative mt-0">
        <div class="flex aic w-full">
          <div
            class="flex flex-col ais jcb top-2-text w-ful space-y-2"
            v-if="selectedCategory"
          >
            <h2 class="nunito-extrabold w-full text-primary-dark capitalize fs-18">{{ selectedCategory.name}}</h2>
            <div
              class="flex flex-col lg:flex-row space-y-3 lg:space-y-0 items-start lg:items-end w-full"
              :class=" selectedCategory.description ? 'jcb' : 'jcs'"
            >
              <p
                v-if="selectedCategory.description"
                class="w-full max-w-md text-gray-600"
              >{{selectedCategory.description}}</p>
              <span
                class="text-gray-900 font-medium flex fs-12 jce"
                v-if="products"
              >
                {{products.length}} {{ products.length == 1 ? $t('product') : $t('products') }} {{$t('in this category')}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div 
      class="flex flex-col lg:flex-row lg:flex-wrap justify-between w-full sm:w-10/12 mx-auto md:w-full pb-32" 
      :class="productImage ? 'py-8 pl-8 pr-4 md:pr-28 md:pl-12 lg:hidden' : 'py-8 pl-5 pr-5 md:pr-24 xl:pr-12 md:pl-12'"
      >
      <div 
        class="flex aic ns-image-w shadow-xl bg-gray-50 relative border border-gray-100 min-h-[100px] mb-8"
        v-for="(product, i) in products"
        :key="i"
      >
        <img
          :src="product.image ? storageUrl + product.image : '/dish.webp'"
          :alt="product.name"
          class="w-[80px] absolute -left-4 filter drop-shadow-lg"
          :class="productImage ? '' : 'hidden'"
        />
        <div class="flex flex-col " :class="productImage ? 'w-8/12 py-4 pr-4 pl-6 mx-auto' : 'w-10/12 px-4 py-4'">
          <h2 class="text-sm nunito-extrabold">{{ product.name }}</h2>
          <span class="fs-11 text-gray-600">{{ product && product.description ? product.description.slice(0, 100) : "" }}</span>
        </div>
        <div class="flex flex-col h-full aic jcc absolute right-3 top-0">
          <div class="mb-2 text-sm nunito-extrabold text-secondary-dark">
            {{ currency }} {{ product.price }}
          </div>
          <button
            type="button"
            v-if="!catalogueMode"
            class="w-[40px] h-[40px] btn-primary flex aic jcc shadow-xl rounded-md"
            aria-label="add-to-cart"
            @click="ClickOnProduct(product)"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
          </button>
        </div>
      </div>

    </div>
    <div class="product-item w-full ais jcs mt-32 mx-auto px-8" :class="productImage ? 'hidden md:flex flex-wrap' : 'hidden'">

      <div
        class="item shadow-xl bg-gray-50 hover:shadow-2xl"
        :class="sideMenu ? 'item-w' : 'item-w-alt'"
        v-for="(product, i) in products"
        :key="i"
      >
        <div class="item-in">
          <div class="items flex flex-col aic jcc md:space-y-2 rounded-5xl">
            <img
              :src="product.image ? storageUrl + product.image : '/dish.webp'"
              :alt="product.name"
              class="items-img"
            />
            <h2 class="nunito-bold text-lg text-center mt-6">
              {{ product.name }}
            </h2>
            <div class="flex space-x-2"><span
                v-for="info in product.allergy_info"
                :key="info"
                :class="info+' text-secondary text-2xl font-bold'"
              ></span></div>

            <div class="flex flex-col aic jcc mb-2 ext-area relative w-full">
              <span class="text-gray-400 b open-sans top-ext flex aic jcc absolute top-0 left-0 w-full h-full"></span>
              <div class="flex flex-wrap aic jcc fs-12 text-gray-500 extras absolute top-0 left-0 w-full h-full pt-3 text-center">
                <span class="mr-1">{{
                  product && product.description ? product.description.slice(0, 100) : ""
                }}</span>
              </div>
            </div>
            <span class="text-primary nunito-bold prod-price">{{ currency }} {{ product.price }}</span>
            <button
              type="button"
              v-if="!catalogueMode"
              class="add-to-cart w-70p h-50p btn-primary mx-auto flex aic jcc shadow-2xl"
              aria-label="add-to-cart"
              @click="ClickOnProduct(product)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

    </div>
    <ProductExtra
      @close="showPackage = false"
      :showPackage="showPackage"
      :product="product"
      :storageUrl="storageUrl"
      :currency="currency"
      :attributes="attributeItems"
      :type="type"
    ></ProductExtra>
    <SideCart
      @closeCard="showCart = false"
      :showCart="showCart"
    ></SideCart>
    <TimePlan
      :showTimePlan="showTimePlan"
      @close="showTimePlan = false"
    ></TimePlan>
  </div>
</div>
</template>
<script>
import ProductExtra from "./ProductExtra.vue";
import MobileCategories from "./MobileCategories.vue";
import SideCart from "./SideCart.vue";
import TimePlan from "./TimePlan.vue";


export default {
  props: ['sideMenuAlt'],
  components: { ProductExtra, MobileCategories, SideCart, TimePlan },
  data() {
    return {
      showCart: false,
      showPackage: false,
      showTimePlan: false,
      product: null,
      type: null,
    };
  },
  computed: {
    sideMenu(){
      if(process.env.VUE_APP_SIDEMENU == 'side_menu') {
        return true
      }
      else {
        return false
      }
    },
    productImage(){
      if(process.env.VUE_APP_PRODUCT_IMAGE == 'true'){
        return true
      }
      else {
        return false
      }
    },
    mainImageTop() {
      if(process.env.VUE_APP_MAIN_IMAGE_TOP == 'mainImageTop') {
        return process.env.VUE_APP_MAIN_IMAGE_TOP
      }
      else {
        return false
      }
    },
    restaurantInfo() {
      return this.$store.state.orderiomApiPackage.restaurant.restaurantInfo;
    },
    selectedCategory() {
      return this.$store.state.orderiomApiPackage.product.selectedCategory;
    },
    products() {
      return this.$store.state.orderiomApiPackage.product.products;
    },
    attributeItems() {
      return this.$store.state.orderiomApiPackage.product.attributeItems;
    },
    storageUrl() {
      return process.env.VUE_APP_STORAGE_URL;
    },
    currency() {
      return this.$store.state.orderiomApiPackage.restaurant.restaurantInfo
        .currency;
    },
    restaurantId() {
      return process.env.VUE_APP_RESTAURANT_ID;
    },
    productPackages() {
      return this.$store.state.orderiomApiPackage.product.productPackage;
    },
    catalogueMode() {
      return process.env.VUE_APP_CATALOGUE_MODE == "true";
    },
  },
  methods: {
    add(productId) {
      this.$store
        .dispatch("order/addToBasket", {
          productId: productId,
          attributeItems: [],
          restaurantId: this.restaurantId,
        })
        .then(() => {
          this.$emit("showCart");
        });
    },
    ClickOnProduct(product) {
      if (
        product.is_package == 0 &&
        !(
          this.attributeItems.length &&
          this.attributeItems.some((attr) => attr.items.length)
        )
      ) {
        this.add(product.id);
        this.showCart = true;
      } else {
        this.product = product;
        if (product.is_package == 1) {
          this.$store
            .dispatch("product/getPackage", {
              productId: product.id,
              restaurantId: this.restaurantId,
            })
            .then(() => {
              if (this.productPackages.length) {
                this.showPackage = true;
                this.type = "package";
              } else if (
                !(
                  this.attributeItems.length &&
                  this.attributeItems.some((attr) => attr.items.length)
                )
              ) {
                this.add(product.id);
                this.showCart = true;
              } else {
                this.type = "attributes";
                this.showPackage = true;
              }
            });
        } else {
          this.type = "attributes";
          this.showPackage = true;
        }
      }
    },
    selectCategory(category) {
      this.$store.commit("product/setSelectedCategory", category);
      this.$store.dispatch("product/getProducts", {
        category: category,
        restaurantId: this.restaurantId,
      });
      this.$store.dispatch("product/getAttributeItems", {
        category: category,
        restaurantId: this.restaurantId,
      });
    },
  },
};
</script>
